var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_627_968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8314 3.02385C20.7134 2.5878 20.4832 2.19026 20.1638 1.87083C19.8444 1.55139 19.4469 1.32121 19.0108 1.2032C17.4145 0.767822 10.9896 0.767822 10.9896 0.767822C10.9896 0.767822 4.56438 0.781001 2.96801 1.21638C2.53195 1.3344 2.13442 1.56459 1.815 1.88404C1.49558 2.20349 1.26542 2.60104 1.14743 3.03711C0.664569 5.87355 0.477256 10.1956 1.16069 12.9186C1.27869 13.3547 1.50885 13.7522 1.82827 14.0716C2.14769 14.3911 2.54522 14.6213 2.98127 14.7393C4.57764 15.1747 11.0027 15.1747 11.0027 15.1747C11.0027 15.1747 17.4276 15.1747 19.0239 14.7393C19.46 14.6213 19.8575 14.3911 20.177 14.0717C20.4964 13.7522 20.7266 13.3547 20.8446 12.9186C21.3539 10.0782 21.5108 5.75872 20.8314 3.02385Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94455 11.0584L14.2745 7.97119L8.94455 4.88403V11.0584Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_627_968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5714,
    height: 14.4643,
    fill: "white",
    transform: "translate(0.714294 0.767822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.ec7a38929da9bca1ad92f92d99c8164e.svg";
export { ForwardRef as ReactComponent };